<template>
  <div class="avatar">
    <AvatarSprite v-if="isAi" :player="player" :moveAction="moveAction" />
    <div v-else class="image">
      <AvatarImg :player="player" />
    </div>
  </div>
</template>

<script>
import AvatarImg from "@/components/players/AvatarImg";
import AvatarSprite from "@/components/players/AvatarSprite";

export default {
  name: "Avatar",

  components: { AvatarImg, AvatarSprite },

  props: ["player", "moveAction"],

  computed: {
    dna() {
      if (!this.player) return null;
      return this.player.dna;
    },

    isAi() {
      if (this.player.aiLevel) return true;
      return false;
    },
  },
};
</script>

<style scoped>
.avatar {
  width: 100%;
  height: 100%;
}
.avatar-sprite {
  width: 100%;
  height: 100%;
}
</style>
